import React from 'react'

const PaymentPage = () => {
    return (
        <section className="max-w-screen-xl mx-auto px-6">
            <h1 className="font-primary text-4xl text-gray-800">Payment Coming soon..............</h1>
        </section>
    )
}

export default PaymentPage
